import React from "react"
import { withStyles, makeStyles } from "@material-ui/core/styles"
import Button from "@material-ui/core/Button"
import Dialog from "@material-ui/core/Dialog"
import MuiDialogTitle from "@material-ui/core/DialogTitle"
import MuiDialogContent from "@material-ui/core/DialogContent"
import MuiDialogActions from "@material-ui/core/DialogActions"
import IconButton from "@material-ui/core/IconButton"
// import CloseIcon from '@material-ui/icons/Close';
import Typography from "@material-ui/core/Typography"

const styles = (theme) => ({
	root: {
		margin: 0,
		padding: theme.spacing(2),
	},
	closeButton: {
		position: "absolute",
		right: theme.spacing(1),
		top: theme.spacing(1),
		color: theme.palette.grey[500],
	},
})

const useStyles = makeStyles({
	dialog: {
		position: "absolute",
		//left: 62,
		top: 50,
	},
})

const DialogTitle = withStyles(styles)((props) => {
	const { children, classes, onClose, ...other } = props
	return (
		<MuiDialogTitle disableTypography className={classes.root} {...other}>
			<Typography variant="h6">{children}</Typography>
			{onClose ? (
				<IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
					<i class="bi bi-x-lg"></i>
				</IconButton>
			) : null}
		</MuiDialogTitle>
	)
})

const DialogContent = withStyles((theme) => ({
	root: {
		padding: theme.spacing(2),
	},
}))(MuiDialogContent)

const DialogActions = withStyles((theme) => ({
	root: {
		margin: 0,
		padding: theme.spacing(1),
	},
}))(MuiDialogActions)

export default function ModalPopup({
	open,
	setOpen,
	title,
	className,
	outSideClickClose = false,
	style = {},
	children,
	showDivider = true,
	showClose = true,
}) {
	//const [open, setOpen] = React.useState(false);
	const classes = useStyles()

	const handleClickOpen = () => {
		setOpen(true)
	}
	const handleClose = () => {
		setOpen(false)
	}

	return (
		<>
			<Dialog
				onClose={handleClose}
				aria-labelledby="customized-dialog-title"
				open={open}
				style={{ minWidth: "400px", maxWidth: "845px", margin: "auto", ...style }}
				fullWidth={true}
				className={className}
				classes={{
					paper: classes.dialog,
				}}
				PaperProps={{
					style: { ...style }, // Apply styles to Paper component
				}}
				//maxWidth={"md"}
			>
				<DialogTitle id="customized-dialog-title" onClose={showClose ? () => setOpen(false) : undefined}>
					{title}
				</DialogTitle>
				<DialogContent dividers={showDivider}>{children}</DialogContent>
				{/* <DialogActions>
          <Button autoFocus onClick={handleClose} color="primary">
            Save changes
          </Button>
        </DialogActions> */}
			</Dialog>
		</>
	)
}
